import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';

const Navbar = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isConsultarOpen, setIsConsultarOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 100);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleConsultarSelect = (type) => {
    setIsConsultarOpen(false);
    console.log(`Selected: ${type}`);
  };

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const navbarHeight = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - navbarHeight;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 bg-white/80 backdrop-blur-md border-b border-gray-100 transition-all duration-300 ${scrolled ? 'shadow-md' : ''}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo + Texto */}
       <div className="flex-shrink-0">
  <a href="/" className="flex items-center gap-4">
    {/* Logo siempre visible */}
    <img 
      src="/logo-black.png" 
      alt="Logo SANZ BERGER" 
      className="h-10 md:h-12 w-auto"
    />
    
    {/* Texto solo en desktop */}
    <div className="hidden md:flex flex-col">
      <span className="text-xl md:text-2xl font-bold tracking-tight text-primary">SANZ BERGER</span>
      <span className="text-[0.6rem] md:text-[0.65rem] font-medium tracking-[0.2em] text-muted-foreground uppercase">
        Bienes Raíces
      </span>
    </div>
  </a>
</div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            <button 
              onClick={() => scrollToSection('propiedades')} 
              className="text-sm font-medium text-foreground/80 hover:text-primary transition-colors"
            >
              Propiedades
            </button>
            <button 
              onClick={() => scrollToSection('nosotros')} 
              className="text-sm font-medium text-foreground/80 hover:text-primary transition-colors"
            >
              Nosotros
            </button>
            <button 
              onClick={() => scrollToSection('contacto')} 
              className="text-sm font-medium text-foreground/80 hover:text-primary transition-colors"
            >
              Contacto
            </button>
            
            <div className="relative">
              <button 
                onClick={() => setIsConsultarOpen(!isConsultarOpen)}
                className="px-8 py-4 bg-primary text-primary-foreground rounded-full font-medium hover:bg-primary/90 transition-all flex items-center justify-center gap-2 group shadow-xl shadow-primary/20"
              >
                Consultar <span>▾</span>
              </button>
              
              {isConsultarOpen && (
                <div className="absolute right-0 mt-2 w-40 bg-white border border-gray-200 rounded-lg shadow-lg z-50">
                  <button 
                    onClick={() => handleConsultarSelect('vender')} 
                    className="block w-full text-left px-4 py-2 text-sm text-foreground hover:bg-gray-100 rounded-lg"
                  >
                    Vender
                  </button>
                  <button 
                    onClick={() => handleConsultarSelect('alquilar')} 
                    className="block w-full text-left px-4 py-2 text-sm text-foreground hover:bg-gray-100 rounded-lg"
                  >
                    Alquilar
                  </button>
                  <button 
                    onClick={() => handleConsultarSelect('tasacion')} 
                    className="block w-full text-left px-4 py-2 text-sm text-foreground hover:bg-gray-100 rounded-lg"
                  >
                    Tasación
                  </button>
                  <button 
                    onClick={() => handleConsultarSelect('contratos')} 
                    className="block w-full text-left px-4 py-2 text-sm text-foreground hover:bg-gray-100 rounded-lg"
                  >
                    Contratos
                  </button>
                </div>
              )}
            </div>
          </div>

          {/* Mobile Menu Button */}
          <button 
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden p-2"
            aria-label="Menú móvil"
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden bg-white border-t border-gray-100">
            <div className="px-4 pt-2 pb-6 space-y-2">
              <button 
                onClick={() => scrollToSection('propiedades')} 
                className="block w-full text-left px-3 py-3 text-base font-medium text-foreground hover:bg-secondary rounded-lg"
              >
                Propiedades
              </button>
              <button 
                onClick={() => scrollToSection('nosotros')} 
                className="block w-full text-left px-3 py-3 text-base font-medium text-foreground hover:bg-secondary rounded-lg"
              >
                Nosotros
              </button>
              <button
                onClick={() => scrollToSection('contacto')}
                className="block w-full text-left px-3 py-3 text-base font-medium text-foreground hover:bg-secondary rounded-lg"
              >
                Contacto
              </button>

              <div className="pt-2 border-t border-gray-100">
                <p className="px-3 pb-2 text-xs font-semibold uppercase tracking-wider text-muted-foreground">
                  Consultar
                </p>
                <button
                  onClick={() => handleConsultarSelect('vender')}
                  className="block w-full text-left px-3 py-3 text-base font-medium text-foreground hover:bg-secondary rounded-lg"
                >
                  Vender
                </button>
                <button
                  onClick={() => handleConsultarSelect('alquilar')}
                  className="block w-full text-left px-3 py-3 text-base font-medium text-foreground hover:bg-secondary rounded-lg"
                >
                  Alquilar
                </button>
                <button
                  onClick={() => handleConsultarSelect('tasacion')}
                  className="block w-full text-left px-3 py-3 text-base font-medium text-foreground hover:bg-secondary rounded-lg"
                >
                  Tasación
                </button>
                <button
                  onClick={() => handleConsultarSelect('contratos')}
                  className="block w-full text-left px-3 py-3 text-base font-medium text-foreground hover:bg-secondary rounded-lg"
                >
                  Contratos
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;